<template>
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g :clip-path="`url(#${clipPathId})`">
      <path
        d="M7.2 5.6h1.6V4H7.2M8 14.4A6.408 6.408 0 0 1 1.6 8c0-3.528 2.872-6.4 6.4-6.4 3.528 0 6.4 2.872 6.4 6.4 0 3.528-2.872 6.4-6.4 6.4ZM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm-.8 12h1.6V7.2H7.2V12Z"
        fill="#140047"
      />
    </g>
    <defs>
      <clipPath :id="clipPathId"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath>
    </defs>
  </svg>
</template>

<script>
import { getUniqueId } from '@/plugins/uniqueId';

export default {
  name: 'exclamation-circle',
  computed: {
    clipPathId: getUniqueId,
  },
};
</script>
